import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	readOnlyLozengeText: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.read-only-lozenge-text',
		defaultMessage: 'Read-Only',
		description:
			'It is a label for the Read-only lozenge displayed next to the plan title when the plan is in read-only mode.',
	},
	collapseToolBar: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.collapse-tool-bar',
		defaultMessage: 'Collapse',
		description: 'Label for the toolbar icon button when the toolbar is expanded in the header',
	},
	expandToolBar: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.expand-tool-bar',
		defaultMessage: 'Expand',
		description: 'Label for the toolbar icon button when the toolbar is collapsed in the header',
	},
	planSettingsViewTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings-view-title',
		defaultMessage: 'Plan title, plan settings and view',
		description: 'Section name for plan controls',
	},
	planSettingsTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings-title',
		defaultMessage: 'Plan title and plan settings',
		description: 'Section name for plan controls',
	},
	filterAndChangeViewTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.filter-and-change-view-title',
		defaultMessage: 'Filter issues and change view settings',
		description: 'Section name for Filter and change view section',
	},
	warningsAndAutoSceduleTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings-and-auto-scedule-title',
		defaultMessage: 'View plan warnings, Share your plan and Auto-schedule issues',
		description:
			'Section name for View plan warnings, Share your plan and Auto-schedule issues section',
	},
	warningsAndShareTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings-and-share-title',
		defaultMessage: 'View plan warnings, Share your plan',
		description: 'Section name for View plan warnings, Share your plan section',
	},
	giveFeedbackTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.give-feedback-title',
		defaultMessage: 'Give feedback',
		description: 'Section name for Give Feedback section',
	},
	giveFeedbackAndReviewTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.give-feedback-and-review-title',
		defaultMessage: 'Give feedback and review changes',
		description: 'Section name for Give feedback and review changes',
	},
});
